module.exports = __webpack_public_path__ + "img/jao02.94284147.jpg";